import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, Modal, Table } from 'antd'
import React, { useEffect } from 'react'
import { useUpdateEventUserMutation } from '../../../api/eventUser.api'
import { useRemoveEmployeeV2Mutation } from '../../../api/v2/employees'
import { useLazyGetMyAssociatesQuery } from '../../../api/v2/users'
import { useMyContext } from '../../../context/context'
import useTranslations from '../../../hooks/useTranslations'
import { useSteps } from '../Steps'

export default function AddAssociates({ show, setShow }) {
  const { myContext, user } = useMyContext()
  const { t } = useTranslations()
  const { resetSteps } = useSteps()

  const [updateParticipation] = useUpdateEventUserMutation()
  const [fetchMyAssociates, { data }] = useLazyGetMyAssociatesQuery()
  const [removeEmployee] = useRemoveEmployeeV2Mutation()

  useEffect(() => {
    if (show) {
      fetchMyAssociates(myContext, false)
    }
  }, [fetchMyAssociates, myContext, show])

  return (
    <Modal
      title={t('REGISTER_COMPANION')}
      visible={show}
      onCancel={() => setShow(false)}
      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button onClick={() => setShow(false)}>{t('CANCEL')}</Button>
          <Button type="primary" onClick={() => resetSteps(5, null)}>
            Créer
          </Button>
        </div>
      }
    >
      <div>{t('REGISTRATION_INSTRUCTIONS')}</div>
      <div style={{ height: 16 }} />
      <Table
        pagination={false}
        size="small"
        dataSource={data}
        columns={[
          {
            render: v => (
              <Button
                type="primary"
                onClick={async () => {
                  await updateParticipation({ ...myContext, userId: v.id, eventUser: { registeredBy2: user.id } }).unwrap()
                  resetSteps(5, v.id)
                }}
                size="small"
                disabled={v.isRegistered}
              >
                {t('CHOOSE')}
              </Button>
            ),
          },
          { title: 'Prénom', dataIndex: 'firstName' },
          { title: 'Nom', dataIndex: 'lastName' },
          { title: 'Société', dataIndex: 'name' },
          {
            title: 'Inscrit',
            dataIndex: 'isRegistered',
            render: isRegistered => {
              if (!isRegistered) {
                return (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CloseCircleOutlined style={{ color: 'red' }} />
                  </div>
                )
              }

              return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <CheckCircleOutlined style={{ color: 'green' }} />
                </div>
              )
            },
          },
          {
            render: v => (
              <Button
                type="primary"
                onClick={() => removeEmployee({ ...myContext, userId: v.id, companyId: v.companyId })}
                size="small"
                danger
              >
                {t('REMOVE')}
              </Button>
            ),
          },
        ]}
      />
    </Modal>
  )
}
